import React, { ReactNode } from 'react';
import { useEntityLogo } from '@hevoio/hevo-ui-toolkit';
import {
  HEVO_WEBSITE_REDIRECT_LINKS,
  HevoWebsiteRedirectEnum
} from '../../../core/constants/constants';
import { AUTH_STRINGS } from '../../constants/strings';
import { HdAuthRequestType } from '../../interfaces/auth';
import styles from './AuthLayout.module.scss';
import { FeaturedCustomers, TestimonialSection } from '../testimonial-section/TestimonialSection';
import {
  HEVO_DARK_THEME_LOGO_SVG,
  HEVO_LIGHT_THEME_LOGO_SVG,
} from '../../../shared/constants/brand-logo';

declare const __DOCS_CONFIG__: any;

export interface HdAuthProps {
  selectedAuthType?: HdAuthRequestType;
  reducedMarginBottom?: boolean;
  featuredCustomers: FeaturedCustomers;
  loginContainerStyles?: React.CSSProperties;
  children: ReactNode;
  heading?: string;
  subheading?: string;
}

export function HdAuth({
  selectedAuthType,
  reducedMarginBottom = false,
  featuredCustomers,
  loginContainerStyles,
  children,
  heading = '',
  subheading = ''
}: HdAuthProps) {
  const selectedAuthString = AUTH_STRINGS[selectedAuthType];
  const brandLogo = useEntityLogo(HEVO_LIGHT_THEME_LOGO_SVG, HEVO_DARK_THEME_LOGO_SVG);

  return (
    <div className='auth-container'>
      <TestimonialSection className='left' featuredCustomers={featuredCustomers} />

      <div className='right'>
        <div className='right-container'>
          <div className={`${styles.authHeading} ${reducedMarginBottom ? 'mb-8' : ''}`}>
            <img
              alt='Hevo'
              className={styles.hevoLogo}
              src={brandLogo}
            />

            <div className='auth-heading-container center-flex-col'>
              <div className='text-headline-3 text-center'>
                {heading || selectedAuthString?.heading}
              </div>

              {(!!selectedAuthString?.subheading || !!subheading) && (
                <div className='text-subheading-1 text-secondary text-center mt-3'>
                  {subheading || selectedAuthString?.subheading}
                </div>
              )}
            </div>
          </div>

          <div className='auth-login-container' style={loginContainerStyles}>
            {children}
          </div>
        </div>

        <footer className='d-flex justify-between'>
          <div className='text-caption-1 text-secondary'>
            © Hevo Data Inc. {new Date().getFullYear()}. All Rights Reserved.
          </div>

          <div className='footer-links-container'>
            <a
              href={HEVO_WEBSITE_REDIRECT_LINKS[HevoWebsiteRedirectEnum.TERMS_OF_SERVICE]}
              className='footer-link'
              target='_blank'
              rel='noreferrer'
            >
              Terms of Use
            </a>

            <a
              href={HEVO_WEBSITE_REDIRECT_LINKS[HevoWebsiteRedirectEnum.PRIVACY_POLICY]}
              className='footer-link'
              target='_blank'
              rel='noreferrer'
            >
              Privacy Policy
            </a>

            <a
              href={__DOCS_CONFIG__.baseURL}
              className='footer-link'
              target='_blank'
              rel='noreferrer'
            >
              Documentation
            </a>

            <a
              href={HEVO_WEBSITE_REDIRECT_LINKS[HevoWebsiteRedirectEnum.BLOG]}
              className='footer-link'
              target='_blank'
              rel='noreferrer'
            >
              Blog
            </a>
          </div>
        </footer>
      </div>
    </div>
  );
}
